<template>
  <v-dialog v-model="dialog" max-width="420" persistent>
    <v-card class="pa-3">
      <v-card-title class="text-h6 d-flex align-center ga-2">
        <v-icon color="error">mdi-alert</v-icon>
        {{ $t("confirm_question") }}
      </v-card-title>

      <v-card-text class="pt-2">
        <div class="text-body-2">
          {{ $t("delete_confirm_message") }}<b>{{ projectName }}</b
          >{{ $t("delete_project_warning") }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          variant="tonal"
          color="secondary"
          @click="dialog = false"
          :disabled="loadingLocal"
        >
          {{ $t("no") }}
        </v-btn>

        <v-btn
          variant="elevated"
          color="error"
          @click="verifyEliminar"
          :loading="loadingLocal"
        >
          {{ $t("yes_delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="tieneEquipos" max-width="420" persistent>
    <v-card class="pa-3">
      <v-card-title class="text-h6 d-flex align-center ga-2">
        <v-icon color="error">mdi-alert</v-icon>
        {{ $t("confirm_question") }}
      </v-card-title>

      <v-card-text class="pt-2">
        <div v-if="datosCargados == false" class="text-body-2">
          {{ $t("delete_with_teams") }} <b>{{ projectName }}</b
          >. {{ $t("linked_teams_warning") }}
        </div>
        <div v-if="datosCargados" class="text-body-2">
          {{ $t("delete_with_teams_data") }} <b>{{ projectName }}</b
          >. {{ $t("linked_teams_model_warning") }}
        </div>
        <div class="mt-3">
          <div class="text-caption font-weight-bold mb-1">
            {{ $t("linked_teams") }}
          </div>

          <v-chip
            v-for="team in equiposProyecto"
            :key="team.id"
            color="warning"
            variant="tonal"
            size="small"
            class="ma-1"
          >
            {{ team.name }}
          </v-chip>
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          variant="tonal"
          color="secondary"
          @click="tieneEquipos = false"
          :disabled="loadingLocal"
        >
          {{ $t("no") }}
        </v-btn>

        <v-btn
          variant="elevated"
          color="error"
          @click="confirmDelete"
          :loading="loadingLocal"
        >
          {{ $t("yes_delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <SnackBarGlobal
    v-model="snakbarVisible"
    :message="snackbarText"
    color="red"
    :timeout="4500"
    :location="top"
  />
</template>
<script>
import SnackBarGlobal from "../Global/SnackBarGlobal.vue";
import { deleteProyecto } from "@/api/proyectos";
import { swal } from "@/utils/swal.js";
import { useSettingsStore } from "@/stores/settings";

export default {
  name: "ReConfirmDelete",
  components: { SnackBarGlobal },
  data() {
    return {
      loadingLocal: false,
      snakbarVisible: false,
      snackbarText: "",
      tieneEquipos: false,
      equiposProyecto: [],
      datosCargados: false,
    };
  },

  props: {
    project: { type: Object, required: true },
    apiPrefix: { type: String, default: "/login" },
    modelValue: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "deleted"],

  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    projectName() {
      return (
        this.project?.nombre ?? this.project?.nameProyect ?? this.projectKey
      );
    },
    projectKey() {
      return this.project?.clave ?? this.project?.idProyect ?? "";
    },
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },

    showError(msg) {
      this.snackbarText = msg;
      this.snakbarVisible = true;
    },
    async verifyEliminar() {
      try {
        const resp = await deleteProyecto(this.projectKey, this.apiPrefix, {
          confirmar_eliminacion: false,
        });

        if (resp.data.tiene_equipo) {
          this.tieneEquipos = true;
          this.equiposProyecto = resp.data.equipos;
          this.datosCargados = resp.data.evidencia;
        } else {
          await this.confirmDelete();
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async confirmDelete() {
      this.loadingLocal = true;
      const result = await deleteProyecto(this.projectKey, this.apiPrefix, {
        confirmar_eliminacion: true,
      });

      if (result.status === 409) {
        this.tieneEquipos = false;
        this.loadingLocal = false;
        this.$emit("deleted");
        this.dialog = false;

       await swal({
          icon: "error",
          title: this.$t("error"),
          text: this.$t("delete_permission_error"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });

        return;
      }
      if (!result.ok) {
        this.showError("Error eliminando");
        this.loadingLocal = false;
        return;
      }
      this.$emit("deleted");
      this.dialog = false;
      this.tieneEquipos = false;
      this.closeDialog();
      this.loadingLocal = false;
      await swal({
        icon: "success",
        title: this.$t("deletion_success"),
        text: this.$t("project_deleted_success"),
        timer: 2500,

        showConfirmButton: false,
        customClass: {
          popup: this.isDark ? "mi-popup" : "mi-popup-2",
          title: "mi-titulo",
        },
      });
    },
  },
};
</script>
